import { Component, NgZone, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { RunService, XMapService } from 'src/app/shared/services';
import { EventManager, Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { MAPDIST } from 'src/app/shared/config';

@Component({
  selector: 'app-subpmap',
  templateUrl: './subpmap.component.html',
  styleUrls: ['./subpmap.component.styl']
})
export class NewShsxsztyxsjlxdtSubpmapComponent implements OnInit {

  swlab  = 0;
  swlabs = [];

  rurl = '';
  model = '';

  deviceMode = null;

  rows = [];
  tmp  = {};

  selMarker = null;

  map       = null;
  infoWin   = null;
  markers   = [];
  markerClusterer = null;

  selid = -1;

  constructor(
    private router: Router,
    private ngZone: NgZone,
    private title: Title,
    private runService: RunService,
    private http: HttpClient,
    private location: Location,
    private route: ActivatedRoute,
    private xmapservice: XMapService,
    private eventManager: EventManager,
  ) { }

  ngOnInit() {
    const model = 'newshsxsztyxsjlxdt';
    this.swlab  = +this.route.snapshot.paramMap.get('swlab');
    const selid = +this.route.snapshot.paramMap.get('selid');
    if (selid > -1) { this.selid = selid; }

    const pObjt = MAPDIST[model];
    if (!pObjt) {
      this.location.back();
      return;
    }
    pObjt.labs = [{val: '', name: ''}];
    this.model  = model;

    this.swlabs = pObjt.labs;

    this.title.setTitle('地图模式 - ' + pObjt.ptitle);
    this.rurl = pObjt.url;

    this.deviceMode = window.orientation;
    this.eventManager.addGlobalEventListener('window', 'orientationchange', (ev: any) => {
      this.deviceMode = window.orientation;
    });

    this.http.get(pObjt.api).toPromise().then((resp: any) => {
      this.rows = resp;
      const swlabsKey = [];
      const swlabs = [];
      for (let i = 0; i < resp.length; i++) {
        const item = resp[i];
        if (!swlabsKey.includes(item.topic)) {
          console.log(item.topic);
          swlabsKey.push(item.topic);
          swlabs.push({val: item.topic, name: item.topic});
        }
      }
      this.swlabs = swlabs;

      this.xmapservice.loadQqMapJs(() => {
        this.loadFullMap();
      });
    });

  }

  loadFullMap() {
    const sw = new window.qq.maps.LatLng(32.597734, 122.667847); // 东北角坐标
    const ne = new window.qq.maps.LatLng(30.078601, 120.618896); // 西南角坐标
    const center = new window.qq.maps.LatLng(31.240692, 121.501751);
    this.map = new window.qq.maps.Map(document.getElementById('qq-full-map-wrapper'), this.xmapservice.getMapOptions({
      zoom: 11,
      minZoom: 8,
      maxZoom: 18,
      center,
      boundary: new window.qq.maps.LatLngBounds(ne, sw)
    }));

    window.qq.maps.event.addListener(this.map, 'click', () => {
      this.infoWin.close(() => {this.closeMarker(); });
    });
    window.qq.maps.event.addListener(this.map, 'zoom_changed', () => {
      this.infoWin.close(() => {this.closeMarker(); });
    });

    const MyOverlay = this.xmapservice.initMyNewOverlay();
    this.infoWin = new MyOverlay({
      map: this.map,
      position: center,
      complete: () => {
          this.swLab(this.swlab);
          // this.loadFullMapMarkers()
      }
    });
  }

  loadFullMapMarkers(kw: string = '') {
    this.infoWin.close(() => {this.closeMarker(); });

    const size = new window.qq.maps.Size(50, 57);
    const bicon   = new window.qq.maps.MarkerImage('/assets/imgs/imed.png', null, null, null, size);
    const biconed = new window.qq.maps.MarkerImage('/assets/imgs/im.png', null, null, null, size);

    let markers;
    if (environment.markerClusterer) {
      if (this.markerClusterer !== null) {
        this.markerClusterer.clearMarkers();
      }
      markers = new window.qq.maps.MVCArray();
    } else {
      markers = [];
      for (let i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null);
      }
    }

    const p = new RegExp(kw, 'i');
    for (let i = 0; i < this.rows.length; i++) {
      const obj = this.rows[i];

      let isCheck = false;
      // filter
      if (kw.length > 0) {
        isCheck = true;
        if (kw == obj.topic) {
          isCheck = false;
        }
      }

      if (isCheck || !obj.location) { continue; }

      let objLatLng;
      let myLatLng;

      const objlocation =  obj.location.split('；')[0];
      objLatLng = objlocation.split(',');
      if (objLatLng.length < 2) { objLatLng = ['31.240692', '121.501751']; }

      myLatLng = new window.qq.maps.LatLng(objLatLng[0], objLatLng[1]);


      const marker = new window.qq.maps.Marker({
        position: myLatLng,
        icon: bicon,
        map: this.map,

        bicon, biconed
      });
      window.qq.maps.event.addListener(marker, 'click', () => {
        this.map.panTo(myLatLng);
        this.infoWin.xsetPosition(myLatLng);
        this.infoWin.setContent(this.getInfoWinHtml(obj));
        this.infoWin.open(() => {this.openMarker(marker); });
      });

      markers.push(marker);

      if (obj.id == this.selid) {
        this.map.setZoom(14);
        this.infoWin.setContent(this.getInfoWinHtml(obj));
        setTimeout(() => {
          this.map.panTo(myLatLng);
          this.infoWin.xsetPosition(myLatLng);
        }, 50);
        this.infoWin.open(() => {this.openMarker(marker); });
      }

    }
    this.markers = markers;

    if (environment.markerClusterer) {
      this.markerClusterer = new window.qq.maps.MarkerCluster({
        maxZoom: 18,
        gridSize: 40,
        map: this.map,
        markers,
        zoomOnClick: true,
        minimumClusterSize: 3,
      });
    }

  }

  getInfoWinHtml(obj: any) {
    let html = '';
    switch (this.model) {
      case 'newshsxsztyxsjlxdt':
          html += '<div style="padding:10px;color: #ffffff;background-color: #2491ff; font-size: 14px">' + obj.name + '</div>';
          html += '<div style="margin:10px;max-height:calc(50vh - 150px);overflow:scroll;color:#2491ff;-webkit-overflow-scrolling: touch">';
          html += '<div style="font-size: 12px;margin-bottom:10px"><span style="color: #2491ff">主题系列：</span>' + obj.topic + '</div>';
          html += '</div>';
          html += '</div>';
          break;
      default:

    }

    return html;
  }

  openMarker(marker: any) {
    if (this.selMarker !== null) { this.closeMarker(); }

    this.selMarker = marker;
    this.selMarker.setIcon(this.selMarker.biconed);
  }
  closeMarker() {
    if (this.selMarker) {
      this.selMarker.setIcon(this.selMarker.bicon);
      this.selMarker = null;
    }
  }

  swLab(i: number) {
    this.swlab = i;
    this.loadFullMapMarkers(this.swlabs[i].val);
  }

  swLabPre() {
    this.swlab -= 1;
    if (this.swlab === -1) { this.swlab = this.swlabs.length - 1; }

    this.loadFullMapMarkers(this.swlabs[this.swlab].val);
  }
  swLabNex() {
    this.swlab += 1;
    if (this.swlab === this.swlabs.length) { this.swlab = 0; }

    this.loadFullMapMarkers(this.swlabs[this.swlab].val);
  }
}
